"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1682],{

/***/ 1682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Page; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ./src/util/SmartEditableArea.tsx
var SmartEditableArea = __webpack_require__(1747);
;// CONCATENATED MODULE: ./src/magnolia/templates/Page/Page.tsx


function Page(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartEditableArea/* SmartEditableArea */.Z, {
        isPreview: props.isPreview,
        slotNode: props.main
    });
}

;// CONCATENATED MODULE: ./src/magnolia/templates/Page/index.ts
/* istanbul ignore file */ 


/***/ }),

/***/ 1747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SmartEditableArea; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5034);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5218);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7378);
/* harmony import */ var _magnolia_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9647);





var EditableArea = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1341), __webpack_require__.e(7351)]).then(__webpack_require__.bind(__webpack_require__, 7351));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7351)
            ];
        }
    }
});
function SmartEditableArea(props) {
    var slotNode = props.slotNode, isPreview = props.isPreview;
    if (isPreview) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Suspense, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EditableArea, {
                className: "EditableArea",
                content: slotNode
            })
        });
    }
    var pageNodes = ((slotNode === null || slotNode === void 0 ? void 0 : slotNode["@nodes"]) || []).map(function(name) {
        return slotNode === null || slotNode === void 0 ? void 0 : slotNode[name];
    }).filter(Boolean);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: pageNodes.map(function(node) {
            var NodeComponent = (0,_magnolia_config__WEBPACK_IMPORTED_MODULE_3__/* .getComponentForMagnoliaTemplate */ .rX)(node["mgnl:template"]);
            if (!NodeComponent) return null;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NodeComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, node), node["@id"]);
        })
    });
}


/***/ })

}]);